var _g, _path, _path2, _path3, _path4, _path5, _rect, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16610_84731)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 65,
    r: 48,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6367 62.3979V75.4889",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7812 62.3979V75.4889",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.207 62.3979V75.4889",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.207 62.3979V75.4889",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2472 56.5873L73.9874 48.1126C74.3036 47.9308 74.6936 47.9355 75.0052 48.125L88.9487 56.5997C89.8129 57.1249 89.4406 58.4542 88.4293 58.4542H59.7456C58.7216 58.4542 58.3594 57.0977 59.2472 56.5873Z",
    fill: "#0056CD",
    stroke: "#0056CD",
    strokeWidth: 1.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.107,
    y: 78.8429,
    width: 31.6286,
    height: 3.10909,
    rx: 1.55455,
    fill: "#0056CD",
    stroke: "#0056CD",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6639 53.8315C76.6639 54.9124 75.7336 55.8592 74.4968 55.8592C73.26 55.8592 72.3297 54.9124 72.3297 53.8315C72.3297 52.7506 73.26 51.8038 74.4968 51.8038C75.7336 51.8038 76.6639 52.7506 76.6639 53.8315Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16610_84731",
    x: 0,
    y: 0,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_16610_84731"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.61734 0 0 0 0 0.666489 0 0 0 0 0.72266 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16610_84731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16610_84731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBubble);
export default __webpack_public_path__ + "static/media/bank-bubble.2af90ae9.svg";
export { ForwardRef as ReactComponent };